
import { defineComponent } from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { Periods, Period } from "@/common/constants";

export default defineComponent({
  name: "NavTop",
  data() {
    return {
      current_user: this.$store.state.auth.current_user,
      periods: Periods[navigator.language],
      Period,
    };
  },
  computed: {
    ...mapGetters({
      dayMonthYear: "calendar/getDateString",
      datePrev: "calendar/getDatePrev",
      dateNext: "calendar/getDateNext",
      isActivedPeriod: "calendar/isActivedPeriod",
      isToday: "calendar/isToday",
    }),
    ...mapState("calendar", ["period", "current_date"]),
    isAgendaRoute() {
      return this.$route.path.startsWith("/agenda");
    },
  },
  methods: {
    showNewAppointmentModal() {
      this.initRecord({});
    },
    ...mapActions({
      initRecord: "record/initRecord",
    }),
  },
});
